import api from './';

export default {
  getRegularTaskTypes() {
    return api.post('RegularTaskTypes/GetList', {}).then(response => response.data);
  },
};
